import { urlApiStatistic } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { ITask } from '~/utils/interface/task';
import { IQueryParamBase } from '~/utils/interface/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  IAccountReceivable,
  IDailyLoadingAssignment,
  IForemanPerformance,
  IOutstandingSiteVisit,
  IOverbooking,
  IPersonalCloseDate,
  IQueryParamDailyLoading,
  IScheduleDashboard,
  IStatistic,
} from '~/utils/interface/statistic';

const statisticApi = {
  getStatisticTodayTask: (params: IQueryParamBase) => {
    const url = urlApiStatistic.getStatisticTodayTask;
    return axiosClient.get<IBaseResponse<IListDataResponse<ITask[]>>>(url, { params });
  },

  getStatisticTodaySchedule: (params: IQueryParamBase) => {
    const url = urlApiStatistic.getStatisticTodaySchedule;
    return axiosClient.get<IBaseResponse<IListDataResponse<IScheduleDashboard[]>>>(url, { params });
  },

  getStatisticQuoteConverted: () => {
    const url = urlApiStatistic.getStatisticQuoteConverted;
    return axiosClient.get<IBaseResponse<IPersonalCloseDate>>(url);
  },

  getStatisticOverbookingItem: () => {
    const url = urlApiStatistic.getStatisticOverbookingItem;
    return axiosClient.get<IBaseResponse<IOverbooking[]>>(url);
  },

  getStatisticOutstandingSiteVisit: (params: IQueryParamBase) => {
    const url = urlApiStatistic.getStatisticOutstandingSiteVisit;
    return axiosClient.get<IBaseResponse<IListDataResponse<IOutstandingSiteVisit[]>>>(url, { params });
  },

  getStatisticDashboardOverview: (type: string) => {
    const url = urlApiStatistic.getStatisticDashboardOverview(type);
    return axiosClient.get<IBaseResponse<IStatistic>>(url);
  },

  getStatisticOrderUnpaidDeposit: (params: IQueryParamBase) => {
    const url = urlApiStatistic.getStatisticOrderUnpaidDeposit;
    return axiosClient.get<IBaseResponse<IListDataResponse<IAccountReceivable[]>>>(url, { params });
  },

  getStatisticOrderDepositNotRequired: (params: IQueryParamBase) => {
    const url = urlApiStatistic.getStatisticOrderDepositNotRequired;
    return axiosClient.get<IBaseResponse<IListDataResponse<IAccountReceivable[]>>>(url, { params });
  },

  getStatisticForemanPerformance: (params: IQueryParamBase) => {
    const url = urlApiStatistic.getStatisticForemanPerformance;
    return axiosClient.get<IBaseResponse<IListDataResponse<IForemanPerformance[]>>>(url, { params });
  },

  getStatisticDailyLoading: (params: IQueryParamDailyLoading) => {
    const url = urlApiStatistic.getStatisticDailyLoading;
    return axiosClient.get<IBaseResponse<IListDataResponse<IDailyLoadingAssignment[]>>>(url, { params });
  },
};

export default statisticApi;
